// Supabase Configuration
const urlFromEnv = import.meta.env.VITE_SUPABASE_URL;
const keyFromEnv = import.meta.env.VITE_SUPABASE_ANON_KEY;

// In production, require explicit env vars to avoid hitting the wrong project with invalid keys
if (import.meta.env.PROD && (!urlFromEnv || !keyFromEnv)) {
	throw new Error('Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY in production environment.');
}

// Allow a development fallback so local runs continue to work without env setup
export const SUPABASE_URL = urlFromEnv || 'https://gdztpryphxlzsobphbme.supabase.co';
export const SUPABASE_ANON_KEY = keyFromEnv || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdkenRwcnlwaHhsenNvYnBoYm1lIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mjg2NDU0MDQsImV4cCI6MjA0NDIyMTQwNH0.lBSohr35UL3LALZya2Acv72JmCCYgjnVLbA0zgjvLng';
